import { useState } from 'react';
export function useDynamicLoading(initialLoading) {
    const [loading, setLoading] = useState(initialLoading || []);
    const handleLoading = () => ({
        get(targets, method = 'some') {
            return loading[method]((item) => targets.includes(item));
        },
        set(targets) {
            targets.forEach((target) => {
                setLoading((prevState) => (!prevState.includes(target) ? [...prevState, target] : [...prevState]));
            });
            return handleLoading();
        },
        remove(targets) {
            targets.forEach((target) => {
                setLoading((prevState) => prevState.filter((state) => target !== state));
            });
            return handleLoading();
        },
        all: loading,
    });
    return { handleLoading };
}
//# sourceMappingURL=index.js.map